import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { Row, Col, Form, Button, Modal, Spinner, InputGroup } from 'react-bootstrap';
import Currency from 'helpers/Currency';
import { api } from 'services';
import { LinkRounded } from '@material-ui/icons';

const ActionsFormTasks = ({ taskItems, setTaskItems, editable, task, statusNow}) => {
  const { t } = useTranslation();
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(false)
  const [itemFile, setItemFile] = useState(null)
  const [showModal, setShowModal] = useState(false)
  
  const file = useMemo(() => {
    if (itemFile != null)
      return { data: itemFile.data }
  }, [itemFile])
  
  const badgesLegends = [
    { label: 'Aguardando Aprovação', variant: 'info'},
    { label: 'Aprovado', variant: 'success' },
    { label: 'Recusado', variant: 'danger' },
    { label: 'Pendente', variant: 'warning' },
  ]

  const renderBriefingName = name => {
    if (name.length > 15) 
      name = name.slice(0,15) +"..."+name.slice(name.length-6, name.length)
    
    return name
  }

  const isDisabled = (item) => {
    
    if(statusNow === 9)
      return !item.is_editable;
    return !editable;
  }

  const handleChange = (name, k, e, is_file = false) => {
    const updateArray = [...taskItems];
    
    updateArray[k][name] = is_file ? [e.target.files[0]] : e.target.value;
    
    setTaskItems(updateArray);
  };

  const otherPropertiesHandleChange = (name, k, e) => {
    const updateArray = [...taskItems];
    var value = e.target.value;
    if(name.indexOf('date') != -1){
      value = new Date(value);
    }
    updateArray[k]['others'][name] = value;
    setTaskItems(updateArray);
  };

  const isEditable = (item) => {
    if(statusNow === 9 && item.is_editable)
    return <b style={{color:'red'}}>*</b>;
    return '';
  }

  // outras propriedades de uma task
  const getOtherProperties = (k,item) => {
    let aux = parseInt(task);
    switch (aux) {
      case 22:
        return (
          <>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>{t('label:base')} {isEditable(item)}</Form.Label>
              <Form.Control
                placeholder="Insira aqui"
                value={item.others.base}
                onChange={e => otherPropertiesHandleChange('base', k, e)}
                required
                disabled={isDisabled(item)}
              />
            </Form.Group>
          </Col>
          </>
        );
      case 52:
        return (
          <>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>Data Inicial {isEditable(item)}</Form.Label>
              <DatePicker
                locale="pt_BR"
                dateFormat="dd/MM/yyyy"
                customInput={<Form.Control />}
                selected={item.others.start_date?new Date(item.others.start_date):''}
                onChange={date =>
                  otherPropertiesHandleChange('start_date', k, { target: { value: date } })
                }
                required
                disabled={isDisabled(item)}
                />
            </Form.Group>
          </Col>
          <Col>
        
          <Form.Group className="m-0">
            <Form.Label>Data Final {isEditable(item)}</Form.Label>
            <DatePicker
              locale="pt_BR"
              dateFormat="dd/MM/yyyy"
              customInput={<Form.Control />}
              selected={item.others.end_date?new Date(item.others.end_date):''}
              onChange={date =>
                otherPropertiesHandleChange('end_date', k, { target: { value: date } })
              }
              required
              disabled={isDisabled(item)}
            />
          </Form.Group>
        
          </Col> 
          </>
        );
      case 53:
        return(
          <>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>Locais {isEditable(item)}</Form.Label>
              <Form.Control
                as="select"
                value={item.others.local?item.others.local:''}
                onChange={(e) => otherPropertiesHandleChange('local',k,e)}
                required
                disabled={isDisabled(item)}
              >
                <option disabled value="">
                  {t('label:select')}
                </option>
                <option value="Facebook">Facebook</option>
                <option value="Instagram">Instagram</option>
                <option value="Linkedin">Linkedin</option>
                <option value="Youtube">Youtube</option>
                <option value="Google">Google</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>Valor {isEditable(item)}</Form.Label>
              <Currency
                value={item.others.value}
                onChange={(e) => otherPropertiesHandleChange('value', k, e)}
                disabled={isDisabled(item)}
                placeholder={t('label:insert here')}
              />
            </Form.Group>
          </Col>
          </>
        );
      default:
        break;
    }
  };

  const handleShow = () => setShowModal(true)
  const handleClose = () => {
    setItem(null)
    setItemFile(null)
    setShowModal(false)
  }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error);
  })

  const renderModal = () => (
    <Modal
      size="lg" 
      centered 
      show={showModal} 
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Subir Briefing  - { item.description }</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col md="7">
            <Form.Group controlId="formFileSm" className="mb-3">
              <Form.Label>Briefing</Form.Label>
              <Form.Control              
                onChange={e => {
                  const [file] = e.target.files
                  setItemFile({ item, file })                  
                }}
                className="form-control form-control-sm" 
                type="file"
                size="sm"
              />
            </Form.Group>
          </Col>
        </Row>        
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" disabled={loading} onClick={() => handleClose()}>Fechar</Button>
        <Button
          disabled={itemFile == null || loading}
          variant="success" 
          onClick={() => {
            setLoading(true)
            var formData = new FormData()

            formData.append('briefing_file[0]', itemFile.file)
            api.post('/actions/change-item-material-complete/'+itemFile.item.id, formData)
            .then(({ data }) => {
              const [{ id, name, uri }] = data
              const _taskItems = taskItems
              const curItemPos = _taskItems.findIndex(item => itemFile.item.id == item.id)
              _taskItems[curItemPos] = {
                ..._taskItems[curItemPos], 
                material_complete: 1,
                briefing: { id: id, name: name, uri: uri }
              }

              if (task == 53) { // verifica se é atividade INPULSIONAMENTO
                _taskItems[curItemPos] = {..._taskItems[curItemPos], enabled_send_arts: 1}
              }

              setTaskItems(_taskItems)
              handleClose()
            })
            .finally(() =>  setLoading(false));
          }}
        >
          <span style={{ color: "#fff" }}>
            Fazer Upload { loading ? <Spinner size="sm" animation="border" /> : <></> }
          </span>          
        </Button>
      </Modal.Footer>
    </Modal>
  )

  const itemBadgeColor = (material_complete, enabled_send_arts) => {
    var option = material_complete
    if (option == 1 && enabled_send_arts == 0) {
      option = 2
    }
    switch (option) {
      case 0: 
        return "danger"
        break;
      case 1:
        return "success"
        break;        
      case 2: 
        return "info"
        break;
      default:
        return "warning"
        break;
    }
  }  

  return (
    <div style={{
      padding: '10px',
      border: '1px solid #c5c5c5',
      borderRadius: '8px'
    }}>
      <div>
        {badgesLegends.map((legend, idx) => {
          return (
            <span key={idx} className={`badge badge-pill badge-${legend.variant} mr-2`}>
              {`Briefing ${legend.label}`}
            </span>
          )
        })}
        <hr />
      </div>
      {taskItems.map((item, k) => (
        <Row key={k} >          
          <Col xs='auto' className='text-center align-middle pr-0'>
            <div className="h-100 w-100 text-center align-middle d-flex flex-column" style={{fontSize: 'x-large'}}>
              <span>{k+1}</span>
              <span className={`badge badge-pill badge-${itemBadgeColor(item.material_complete, item.enabled_send_arts)}`}>
                {' '}
              </span>
            </div>
          </Col>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>{t('label:theme')} {isEditable(item)}</Form.Label>
              <Form.Control
                placeholder="Insira aqui"
                value={item.description}
                onChange={e => handleChange('description', k, e)}
                required
                disabled={isDisabled(item)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="m-0">
              <Form.Label>{t('label:delivery date')} {isEditable(item)}</Form.Label>
              <DatePicker
                locale="pt_BR"
                dateFormat="dd/MM/yyyy"
                customInput={<Form.Control />}
                selected={item.delivery_date}
                onChange={date =>
                  handleChange('delivery_date', k, { target: { value: date } })
                }
                required
                disabled={isDisabled(item)}
              />
            </Form.Group>
          </Col>
          {getOtherProperties(k,item)}
          
          {item.briefing ? (
            <Col sm="2">
              <Form.Group className="m-0">
                <Form.Label>Briefing</Form.Label>                
                <InputGroup className="mb-3">
                  <a href={item.briefing ? item.briefing.uri : null} target='_blank'>
                    {renderBriefingName(item.briefing.name)} <LinkRounded />
                  </a>
                </InputGroup>
              </Form.Group>
            </Col>
          ) : (<></>)}
          
          
          {(item.material_complete == 0 || item.material_complete == null) && statusNow != 0 && item.id ? (<>
            <Col sm="2">
              <Form.Group>
                <Form.Label>{' '}</Form.Label>
                <Button
                  className="mt-4" 
                  variant="info" 
                  size="sm"
                  onClick={async () => {
                    await Promise.resolve().then(() => {
                      setItem(item)
                    })
                    handleShow()
                  }}
                >
                  Subir Briefing
                </Button>
              </Form.Group>
            </Col>
          </>) : (<>
            {!item.id ? (
              <Col sm="auto">
                <Form.Group controlId="formFileSm" className="mb-3">
                  <Form.Label>Briefing</Form.Label>
                  <Form.Control 
                    type="file" 
                    size="sm" 
                    onChange={e => {
                      //const [file] = e.target.files
                      handleChange('briefing_file', k, e, true)
                    }}
                  />
                </Form.Group>
              </Col>
            ):(<></>)}
          </>)}
          {taskItems.length !== k+1?
            <Col xs="12" className="pt-0 pb-0"><hr></hr></Col>
          :''}
        </Row>
      ))}
      {item ? renderModal() : <></>}
    </div>
  );
};

export default ActionsFormTasks;
